
import { Routes, Route } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { HostSidebar } from "@/components/host/HostSidebar";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import HostDashboardPage from "@/pages/host/HostDashboardPage";
import HostPropertiesPage from "@/pages/host/HostPropertiesPage";
import HostBookingsPage from "@/pages/host/HostBookingsPage";
import HostMessagesPage from "@/pages/host/HostMessagesPage";
import HostEarningsPage from "@/pages/host/HostEarningsPage";
import HostSettingsPage from "@/pages/host/HostSettingsPage";
import HostAnalyticsPage from "@/pages/host/HostAnalyticsPage";
import AddPropertyPage from "@/pages/host/AddPropertyPage";
import EditPropertyPage from "@/pages/host/EditPropertyPage";
import HostOnboardingPage from "@/pages/host/HostOnboardingPage";
import HostPaymentMethodsPage from "@/pages/host/HostPaymentMethodsPage";
import AddPaymentMethodPage from "@/pages/host/AddPaymentMethodPage";
import HostVerificationPage from "@/pages/host/HostVerificationPage";
import AIAssistantPage from "@/pages/host/AIAssistantPage";

const HostLayout = () => {
  const isMobile = useIsMobile();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        {isMobile ? (
          <Sheet>
            <SheetTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon" 
                className="fixed top-4 left-4 z-50 md:hidden"
              >
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="p-0 w-[80%] sm:w-[300px]">
              <div className="h-full overflow-auto">
                <HostSidebar />
              </div>
            </SheetContent>
          </Sheet>
        ) : (
          <HostSidebar />
        )}
        <main className="flex-1 overflow-x-hidden px-4 py-4 sm:px-6 sm:py-6">
          {isMobile && <div className="h-12"></div>} {/* Spacer for mobile menu button */}
          <Routes>
            <Route path="/" element={<HostDashboardPage />} />
            <Route path="/properties" element={<HostPropertiesPage />} />
            <Route path="/properties/add" element={<AddPropertyPage />} />
            <Route path="/properties/edit/:id" element={<EditPropertyPage />} />
            <Route path="/bookings" element={<HostBookingsPage />} />
            <Route path="/messages" element={<HostMessagesPage />} />
            <Route path="/earnings" element={<HostEarningsPage />} />
            <Route path="/settings" element={<HostSettingsPage />} />
            <Route path="/analytics" element={<HostAnalyticsPage />} />
            <Route path="/onboarding" element={<HostOnboardingPage />} />
            <Route path="/payment-methods" element={<HostPaymentMethodsPage />} />
            <Route path="/add-payment-method" element={<AddPaymentMethodPage />} />
            <Route path="/verification" element={<HostVerificationPage />} />
            <Route path="/ai-assistant" element={<AIAssistantPage />} />
          </Routes>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default HostLayout;
